var map = {
	"./link.svg": 317,
	"./presentation_1.svg": 629,
	"./presentation_2.svg": 630,
	"./presentation_3.svg": 631,
	"./presentation_4.svg": 632
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 316;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neonat/icons ^\.\/.*\.svg$
// module id = 316
// module chunks = 1